export const INITIAL_STATE = {
     deveRedirecionarParaTodosServicos: false,
     pedidoRecomendado: {},
     servicoCidadao: [],
     servicos: [],
     error: null,
     loading: false,
     gRecaptchaResponse: "",
     dadosFormulario: {
          nome: "",
          cpf: "",
          dataNascimento: ""
     },
}

export default function reducer(state = INITIAL_STATE, action) {
     switch (action.type) {
          case "ERRO_BUSCAR_CIDADAO": 
               return { ...state, loading: false, error: true }
          case "ERRO_SERVICO_INDISPONIVEL":
               return { ...state, loading: false, error: { type: 'servico_indisponivel' } }
          case "INICIAR_BUSCAR_CIDADAO":
               return { ...state, loading: true };
          case "RESET_RECAPTCHA_RESPONSE":
               return {
                    ...state,
                    loading: false,
                    gRecaptchaResponse: "",
                    error: null,
               };
          case "NOVO_PEDIDO_RECAPTCHA_RESPONSE_ATUALIZADO":
               return {
                    ...state,
                    loading: false,
                    gRecaptchaResponse: action.payload,
               };
          case 'GET_TODOS_SERVICOS':
               return { ...state, loading: true }
          case 'GET_TODOS_SERVICOS_ERROR':
               return { ...state, loading: false, error: action.payload }
          case 'GET_TODOS_SERVICOS_SUCCESS':
               return { ...state, loading: false, servicos: action.payload }
          case 'PEDIDO_RECOMENDADO_GET_ALL_REQUEST':
               return { ...state, loading: true, pedidoRecomendado: action.payload };
          case 'PEDIDO_RECOMENDADO_GET_ALL_SUCCESS':
               return { ...state, loading: false, pedidoRecomendado: action.payload };
          case 'PEDIDO_RECOMENDADO_GET_ALL_FAILURE':
               return { ...state, loading: false, pedidoRecomendado: action.payload };
          case 'PEDIDOS_RECOMENDADOS_GET_BY_ID_REQUEST':
               return { ...state, loading: true, servicoCidadao: action.payload };
          case 'PEDIDOS_RECOMENDADOS_GET_BY_ID_SUCCESS':
               if (action.payload?.length <= 5) {
                    return { ...state, loading: false, servicoCidadao: action.payload, deveRedirecionarParaTodosServicos: true };
               }
               return { ...state, loading: false, servicoCidadao: action.payload, deveRedirecionarParaTodosServicos: false };
          case 'PEDIDOS_RECOMENDADOS_GET_BY_ID_FAILURE':
               return { ...state, loading: false, error: action.payload };
          case 'SALVAR_DADOS_FORMULARIO':
               return { ...state, dadosFormulario: action.payload };
          case 'LIMPAR_DADOS_FORMULARIO':
               return { ...state, dadosFormulario: { nome: "", cpf: "", dataNascimento: "" } };

          default:
               return state;
     }
}